import React from 'react';
import {History} from 'history';
import {Loading} from '../loading/loading';
import Loadable from "react-loadable";
import {lazyInject} from '../../services/container';
import {Server} from '../../services/server';
import {PageComponent, PageComponentProps} from '../pageComponent';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import successIcon from '../../assets/images/success_icon.svg';
import {getCurrentUser, User} from "../../models/user";

interface SuccessPageProps extends PageComponentProps
{
    history: History;
}

export class SuccessPage extends PageComponent<SuccessPageProps>
{
    @lazyInject(Server)
    private server: Server;
    
    private loadableComponent: any;

    public constructor(props: SuccessPageProps, context: any)
    {
        super(props, context);

        this.loadableComponent = Loadable({
            loader: () => getCurrentUser() as Promise<{ name: string }>,
            loading: () => <Loading />,
            render: (user: { name: string }, props: { history: History }) => {
                return this.renderLoaded(user);
            }
        });
    }

    public render(): React.ReactNode
    {
        const LoadableComponent = this.loadableComponent;
        return <>
            <DocumentTitle title={this.translate.translate('reserveSuccessPageTitle') as any as string} />
            <LoadableComponent history={this.props.history} />
        </>;
    }
    
    private renderLoaded(user: { name: string }): React.ReactNode
    {
        return <div className={classNames('nav-page', 'success-page')}>
            <img className="success-icon" src={successIcon} />
            <div className="success-page-title">
                {this.translate.translate('successLine1')}
            </div>
            <div className="top-logo-sep" />
            <div className="success-page-text">
                <div className="success-page-greeting">
                    {this.translate.translate('successLine2', {name: user.name})}
                </div>
                <div className="success-page-p1">
                    {this.translate.translate('successLine3')}
                </div>
                <div className="success-page-p2">
                    {this.translate.translate('successLine4')}
                </div>
                <div className="success-page-p3">
                    {this.translate.translate('successLine5')}
                </div>
                <div className="success-page-p4">
                    {this.translate.translate('successLine6')}
                </div>
            </div>
        </div>;
    }
}